import { IDropdownOption } from "@fluentui/react";

export const RATIOS_OPTIMIZAR: IDropdownOption[] = [
    { key: "pca", text: "Puntos IronIA" },
    { key: "linear_return", text: "Retorno anualizado" },
    { key: "volatility", text: "Volatilidad" },
    { key: "gastos_corrientes", text: "Gastos Corrientes" },
    { key: "clase_limpia", text: "Clase Limpia" },
    { key: "alpha", text: "Alpha" },
    { key: "bear_beta", text: "Bear Beta" },
    { key: "beta", text: "Beta" },
    { key: "bull_beta", text: "Bull Beta"},
    { key: "calmar", text: "Calmar" },
    { key: "correlation", text: "Correlación" },
    { key: "downside_deviation", text: "Downside Risk" },
    { key: "information_ratio", text: "Information Ratio" },
    // { key: "log_annualized_return", text: "Retorno anualizado" },
    { key: "max_drown", text: "Máxima caída" },
    { key: "omega", text: "Omega" },
    { key: "sharpe", text: "Sharpe" },
    { key: "sortino", text: "Sortino" },
    { key: "time_to_recovery", text: "Tiempo de recuperación" },
    { key: "tracking_error", text: "Tracking error" },
    { key: "treynor", text: "Treynor" },   
]

export const PERIODOS_OPTIMIZAR = [
    { key: "1y", text: "1Y" },
    { key: "2y", text: "2Y" },
    { key: "3y", text: "3Y" },
    { key: "4y", text: "4Y" },
    { key: "5y", text: "5Y" },
]